import axios from 'axios';
import { redirectToSystemUnavailable } from '../routes/navigation';

// Global Axios response interceptor to catch server/network failures
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status as number | undefined;
    const hasResponse = !!error?.response;

    // No response (network error/timeout) OR HTTP 5xx
    if (!hasResponse || (typeof status === 'number' && status >= 500)) {
      redirectToSystemUnavailable();
    }

    return Promise.reject(error);
  },
);

